module.exports = __webpack_public_path__ + "static/img/partner-txzw.3d3f882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-txzw.png
// module id = JK1l
// module chunks = 34